var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.438 3.53516V9.64476M12.2188 3.53516V9.64476",
    stroke: "#0B60D6",
    strokeWidth: 3.09504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.86 6.5918H16.8052C11.045 6.5918 8.16487 6.5918 6.3754 8.38125C4.58594 10.1707 4.58594 13.0508 4.58594 18.811V21.8658C4.58594 27.6259 4.58594 30.5062 6.3754 32.2955C8.16487 34.085 11.045 34.085 16.8052 34.085H19.86C25.6201 34.085 28.5003 34.085 30.2897 32.2955C32.0792 30.5062 32.0792 27.6259 32.0792 21.8658V18.811C32.0792 13.0508 32.0792 10.1707 30.2897 8.38125C28.5003 6.5918 25.6201 6.5918 19.86 6.5918Z",
    stroke: "#0B60D6",
    strokeWidth: 3.09504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58594 15.7559H32.0792",
    stroke: "#0B60D6",
    strokeWidth: 3.09504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.801 21.8672H24.438M12.2188 21.8672H12.2325M19.8558 27.9768H12.2188M24.438 27.9768H24.4242",
    stroke: "#0B60D6",
    strokeWidth: 3.09504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fd28171bbfba5bfa5edb1d03ae996b4f.svg";
export { ForwardRef as ReactComponent };